<template>
    <div class="upsell-option">
        <figure v-if="isMobile" ref="upsellImageLayer">
            <img
                alt=""
                :src="productImage.placeholder"
                :data-src="productImage.src"
                :class="productImage.class"
                :data-width="productImage.width">
        </figure>

        <label :for="'upsell-product-' + product.id" :class="{'selected': selected}">
            <span class="upsell-product-title" v-html="productName"></span>
            <span class="upsell-product-description">{{ product.description }}</span>
            <div class="upsell-product-price">
                <span>
                    {{resources.bundlePrice.formattedSale}}
                </span>
                <span v-if="resources.unitBasePrice">
                    {{resources.vatIncluded}}
                    {{resources.unitBasePriceLabel}}
                    {{resources.unitBasePrice.original_volume}}
                    {{resources.unitBasePrice.base_price_text}}
                </span>
            </div>
        </label>

        <input
            type="radio"
            name="product-option"
            :id="'upsell-product-' + product.id"
            :value="product.id"
            :disabled="!product.available"
            :checked="selected"
            @click="setSelected()">

        <span class="error-message" v-if="!product.available">{{ resources.notInStockShort }}</span>
    </div>
</template>

<script src="./product-tile.js"/>
